import { Link } from "react-router-dom";

export default function TermsConditions() {
  return (
    <div className="min-h-screen flex flex-col items-center px-6 py-10 md:px-16 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="max-w-4xl w-full bg-white dark:bg-gray-800 p-6 md:p-10 rounded-lg shadow-lg">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">Terms & Conditions</h1>

        <div className="space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
          <p>
            These Terms and Conditions, along with privacy policy or other terms (“Terms”)
            constitute a binding agreement by and between SHIKHA JAIN, (“Website Owner” or “we” or
            “us” or “our”) and you (“you” or “your”) and relate to your use of our website, goods
            (as applicable) or services (as applicable) (collectively, “Services”).
          </p>

          <p>
            By using our website and availing the Services, you agree that you have read and
            accepted these Terms (including the Privacy Policy). We reserve the right to modify
            these Terms at any time and without assigning any reason. It is your responsibility to
            periodically review these Terms to stay informed of updates.
          </p>

          <h2 className="text-2xl font-semibold mt-4">1. Use of Website and Services</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              To access and use the Services, you agree to provide true, accurate and complete
              information during and after registration. You are responsible for all actions taken
              via your registered account.
            </li>
            <li>
              Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
              timeliness, performance, completeness or suitability of the information and materials
              offered on this website or through the Services.
            </li>
            <li>
              Your use of our Services and the website is solely at your own risk and discretion.
              You must independently assess whether the Services meet your requirements.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-4">2. Intellectual Property</h2>
          <p>
            The contents of the Website and Services are proprietary to us. You do not have any
            authority to claim intellectual property rights, title, or interest in the contents.
          </p>

          <h2 className="text-2xl font-semibold mt-4">3. Unauthorized Use</h2>
          <p>
            Unauthorized use of the Website or Services may lead to action against you under these
            Terms or applicable laws.
          </p>

          <h2 className="text-2xl font-semibold mt-4">4. Payments & Refunds</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>You agree to pay us the charges associated with availing the Services.</li>
            <li>
              You shall be entitled to claim a refund in case we are not able to provide the
              Services. Refund timelines depend on the specific Service or our refund policies.
            </li>
            <li>
              If you fail to raise a refund request within the stipulated time, you will not be
              eligible for a refund.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-4">5. Legal Compliance</h2>
          <p>
            You agree not to use the website or Services for any unlawful, illegal, or forbidden
            purposes under these Terms or applicable Indian/local laws.
          </p>

          <h2 className="text-2xl font-semibold mt-4">6. Third-Party Links</h2>
          <p>
            The website and Services may contain links to third-party websites. When accessing such
            links, you are subject to the terms, privacy policy, and other policies of those
            websites.
          </p>

          <h2 className="text-2xl font-semibold mt-4">7. Binding Agreement</h2>
          <p>
            By initiating a transaction to avail Services, you enter into a legally binding and
            enforceable contract with us for the said Services.
          </p>

          <h2 className="text-2xl font-semibold mt-4">8. Force Majeure</h2>
          <p>
            We shall not be liable for any failure to perform our obligations if such failure is due
            to a force majeure event.
          </p>

          <h2 className="text-2xl font-semibold mt-4">9. Governing Law & Jurisdiction</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of India. All
            disputes shall be subject to the exclusive jurisdiction of the courts in Faridabad,
            Haryana.
          </p>

          <h2 className="text-2xl font-semibold mt-4">10. Contact</h2>
          <p>
            All concerns or communications relating to these Terms must be sent to us using the
            contact information provided on the website.
          </p>
        </div>

        <p className="mt-6 text-center text-sm text-gray-700 dark:text-gray-300">
          If you have any questions, contact us at
          <span className="font-semibold text-blue-600 dark:text-blue-400">
            {" "}
            printkaro369@gmail.com
          </span>
          .
        </p>

        <div className="mt-6 text-center">
          <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
